import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import ProductInfoContainer, { mainBreakpoints } from '../common/ProductInfoContainer';
import { SuiteTiles } from '../merch-card/SuiteTiles';
import SplashPageHeader from '../splash-page/SplashPageHeader';
import UpgradeConfigContent from './UpgradeConfigContent';
const HeroBG = styled.div.withConfig({
  displayName: "UpgradeModalHeroBanner__HeroBG",
  componentId: "sc-1v7yb5c-0"
})(["width:100%;z-index:-1;background-color:", ";"], GYPSUM);
const ContentContainer = styled.div.withConfig({
  displayName: "UpgradeModalHeroBanner__ContentContainer",
  componentId: "sc-1v7yb5c-1"
})(["", " padding-bottom:42px;margin-bottom:32px;"], mainBreakpoints);

const UpgradeModalHeroBanner = ({
  upgradePointApiName,
  upgradeConfig
}) => {
  if (!upgradeConfig) {
    return /*#__PURE__*/_jsxs("div", {
      className: "m-top-8",
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-bottom-8",
        children: /*#__PURE__*/_jsx(SplashPageHeader, {
          titleKey: "pricingPage.pages.suiteStarter.title",
          subtitleKey: "pricingPage.pages.suiteStarter.subtitle"
        })
      }), /*#__PURE__*/_jsx(ProductInfoContainer, {
        style: {
          margin: 'auto'
        },
        children: /*#__PURE__*/_jsx(SuiteTiles, {
          isFreeToStarter: true
        })
      })]
    });
  }

  return /*#__PURE__*/_jsx(HeroBG, {
    children: /*#__PURE__*/_jsx(ContentContainer, {
      className: "m-x-auto",
      children: /*#__PURE__*/_jsx(UpgradeConfigContent, {
        upgradePointApiName: upgradePointApiName,
        upgradeConfig: upgradeConfig
      })
    })
  });
};

export default UpgradeModalHeroBanner;